namespace $ { export class $mol_checker extends $mol_clicker {

	/// checked false
	@ $mol_mem()
	checked( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : false
	}

	/// attr * mol_checker_checked > checked
	attr() {
		return $mol_merge_dict( super.attr() , {
			"mol_checker_checked" : ( next? : any , prev? : any )=> <any> this.checked( next , prev ) ,
		} )
	}

	/// icon null
	icon() {
		return <any> null
	}

	/// label /
	label() {
		return [] as any[]
	}

	/// labeler $mol_viewer childs / < label
	@ $mol_mem()
	labeler( next? : any , prev? : any ) {
		return new $mol_viewer().setup( obj => { 
			obj.childs = () => [].concat( this.label() )
		} )
	}

	/// childs / 
	/// 	< icon 
	/// 	< labeler
	childs() {
		return [].concat( this.icon() , this.labeler() )
	}

} }

